import React from 'react';
import { WpIcon } from 'Wpds/components/icon';

type Props = {
  feed;
};

export default ({ feed }: Props) => {
  if (!feed || feed.length === 0) return null;

  return (
    <div className="activity-feed">
      <div className="mb-4 p-4 pb-4">
        <h5 className="mt-0 mb-4">Recent Activity</h5>
        <div style={{ marginBottom: '3rem' }}>
          {feed.map(([date_label, events]) =>
            events.map(event => (
              <div key={`${event.recommendation_id}-${event.type}`} className="mb-3 assist">
                <div className="date">
                  {event.type === 'closed_through_workpatterns' && <WpIcon name="check-square" className="mr-2" />}
                  {event.type === 'dismissed' && <WpIcon name="times-square" className="mr-2" />}
                  {event.type === 'received' && <WpIcon name="envelope-open-text" className="mr-2" />}
                  {date_label}
                </div>
                <span className="font-weight-bold">{event.user_label}</span>{' '}
                {event.type === 'closed_through_workpatterns' && <>closed</>}
                {event.type === 'dismissed' && <>dismissed</>}
                {event.type === 'received' && <>received</>}
                {' nudge '}
                <span>
                  {'"'}
                  {event.recommendation_label}
                  {'"'}
                </span>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
};
